'use client';

import React, { useEffect, useRef } from 'react';
import Script from 'next/script';

export default function ResultsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let ctx: any;

    const init = async () => {
      const { gsap } = await import('gsap');
      const { ScrollTrigger } = await import('gsap/ScrollTrigger');

      gsap.registerPlugin(ScrollTrigger);

      ctx = gsap.context(() => {
        // Title animation
        if (titleRef.current) {
          gsap.fromTo(
            Array.from(titleRef.current.children),
            {
              opacity: 0,
              y: 35,
            },
            {
              opacity: 1,
              y: 0,
              duration: 0.9,
              stagger: 0.12,
              ease: 'power3.out',
              scrollTrigger: {
                trigger: titleRef.current,
                start: 'top 82%',
              },
            }
          );
        }
      }, sectionRef);
    };

    init();

    return () => ctx?.revert();
  }, []);

  return (
    <section data-component-id="src/app/components/ResultsSection.tsx:50:4" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="50" data-component-end-line="98" data-component-file="ResultsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22results%22%2C%22className%22%3A%22py-24%20lg%3Apy-36%20bg-%5B%23F5F7FA%5D%20overflow-hidden%22%7D"
      ref={sectionRef}
      id="results"
      className="py-24 lg:py-36 bg-[#F5F7FA] overflow-hidden"
    >
      <div data-component-id="src/app/components/ResultsSection.tsx:55:6" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="55" data-component-end-line="90" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%20lg%3Apx-12%22%7D" className="max-w-7xl mx-auto px-6 lg:px-12">

        {/* Title */}
        <div data-component-id="src/app/components/ResultsSection.tsx:58:8" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="58" data-component-end-line="80" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20lg%3Agrid-cols-12%20gap-8%20mb-16%20lg%3Amb-20%20items-end%22%7D"
          ref={titleRef}
          className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16 lg:mb-20 items-end"
        >
          <div data-component-id="src/app/components/ResultsSection.tsx:62:10" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="62" data-component-end-line="73" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-6%22%7D" className="lg:col-span-6">
            <span data-component-id="src/app/components/ResultsSection.tsx:63:12" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="63" data-component-end-line="65" data-component-file="ResultsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22inline-block%20text-%5B10px%5D%20font-black%20uppercase%20tracking-%5B0.4em%5D%20text-%5B%230C3E97%5D%20mb-4%22%2C%22textContent%22%3A%22Testimonials%22%7D" className="inline-block text-[10px] font-black uppercase tracking-[0.4em] text-[#0C3E97] mb-4">
              Testimonials
            </span>

            <h2 data-component-id="src/app/components/ResultsSection.tsx:67:12" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="67" data-component-end-line="72" data-component-file="ResultsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20md%3Atext-4xl%20lg%3Atext-5xl%20font-black%20tracking-tight%20text-%5B%230F172A%5D%20leading-%5B1.1%5D%22%2C%22textContent%22%3A%22What%20parents%20and%20students%22%7D" className="text-3xl md:text-4xl lg:text-5xl font-black tracking-tight text-[#0F172A] leading-[1.1]">
              What parents and students{' '}
              <span data-component-id="src/app/components/ResultsSection.tsx:69:14" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="69" data-component-end-line="71" data-component-file="ResultsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-%5B%230C3E97%5D%22%2C%22textContent%22%3A%22say%20about%20us.%22%7D" className="text-[#0C3E97]">
                say about us.
              </span>
            </h2>
          </div>

          <div data-component-id="src/app/components/ResultsSection.tsx:75:10" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="75" data-component-end-line="79" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22lg%3Acol-span-4%20lg%3Acol-start-9%22%7D" className="lg:col-span-4 lg:col-start-9">
            <p data-component-id="src/app/components/ResultsSection.tsx:76:12" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="76" data-component-end-line="78" data-component-file="ResultsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-base%20text-%5B%2364748B%5D%20leading-relaxed%22%2C%22textContent%22%3A%22Every%20word%20here%20is%20earned%20through%20consistent%20teaching%2C%20personal%20attention%2C%20and%20a%20method%20that%20truly%20works.%22%7D" className="text-base text-[#64748B] leading-relaxed">
              Every word here is earned through consistent teaching, personal attention, and a method that truly works.
            </p>
          </div>
        </div>

        {/* Featurable Reviews Only */}
        <div data-component-id="src/app/components/ResultsSection.tsx:83:8" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="83" data-component-end-line="88" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-3xl%20border%20border-%5B%23EAECEF%5D%20p-6%20lg%3Ap-8%20shadow-sm%22%7D" className="bg-white rounded-3xl border border-[#EAECEF] p-6 lg:p-8 shadow-sm">
          <div data-component-id="src/app/components/ResultsSection.tsx:84:10" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="84" data-component-end-line="87" data-component-file="ResultsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22featurable-6e23bb6f-e9d0-4083-9642-6e81800c5883%22%7D"
            id="featurable-6e23bb6f-e9d0-4083-9642-6e81800c5883"
            data-featurable-async
          />
        </div>

      </div>

      {/* Featurable Script */}
      <Script data-component-id="src/app/components/ResultsSection.tsx:93:6" data-component-path="src/app/components/ResultsSection.tsx" data-component-line="93" data-component-end-line="97" data-component-file="ResultsSection.tsx" data-component-name="Script" data-component-content="%7B%22elementName%22%3A%22Script%22%2C%22src%22%3A%22https%3A%2F%2Ffeaturable.com%2Fassets%2Fbundle.js%22%7D"
        src="https://featurable.com/assets/bundle.js"
        strategy="afterInteractive"
        charSet="UTF-8"
      />
    </section>
  );
}